import React from 'react';
import _ from 'lodash';

import { BookingCard } from '../../cards/booking-card';
import { IRosterBooking } from '../../types';
import { ROSTER_TAB } from 'views/bookings/roster-view/common/roster-common-enums';

interface BookingCardListProps {
  bookings?: IRosterBooking[][];
}

/** Local component for filtering out bookings for the selected day. */
export const BookingCardList = ({ bookings }: BookingCardListProps) => {
  return (
    <>
      {bookings?.map((bookingGroup, rowIdx) =>
        bookingGroup.map((booking, bookingIdx) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <BookingCard booking={booking} key={bookingIdx} tab={ROSTER_TAB.DAILY} rowIndex={rowIdx} />
        )),
      )}
    </>
  );
};
